/* eslint-disable prefer-destructuring */
/* eslint-disable consistent-return */
import { CircularProgress } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import { getLabel } from "helpers/dictionary";
import { useEffect, useState } from "react";
import WhitelistItemV2 from "components/Custom/LittleForm/Inputs/Whitelist/WhitelistItemV2";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import formActions from "redux-react/actions/formAction";

const InputString = ({ filter, page, language, storage, updateStoreFilter }) => {
	const dispatch = useDispatch();
	const assistantID = useSelector(state => selectCurrentProfile(state).assistantID);

	const [listOfApis, setListOfApis] = useState([]);
	const [loadingApis, setLoadingApis] = useState(true);

	const [currentValue, setCurrentValue] = useState(storage);

	useEffect(() => {
		setCurrentValue(storage);
	}, [storage]);

	/**
	 * Load list of APIs from backend
	 */
	useEffect(() => {
		// Skip loading if listOfApis is provided in options
		if (listOfApis && listOfApis.length > 0) {
			return;
		}

		// Skip loading if assistantID is not available yet
		if (!assistantID) {
			return;
		}

		setLoadingApis(true);
		dispatch(
			formActions.getListApis(assistantID, res => {
				const apisList = res?.apisList || [];
				setListOfApis(apisList);
				setLoadingApis(false);
			})
		);
	}, [filter]);

	if (loadingApis) {
		return (
			<MDBox key={filter.attribute} mr={1} display="flex" alignItems="center" p={1}>
				<CircularProgress size={20} />
			</MDBox>
		);
	}

	return (
		<MDBox key={filter.attribute} mr={1}>
			<WhitelistItemV2
				label={getLabel(filter.label, language)}
				value={currentValue}
				onChange={newValue => {
					setCurrentValue(newValue);
					updateStoreFilter(newValue, filter, page);
				}}
				item={{
					whitelistDynamic: filter?.whitelistDynamic || {}
				}}
				listOfApis={listOfApis}
				InputProps={{}}
				isArray
			/>
		</MDBox>
	);
};

export default InputString;
